class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    this.minInput = this.querySelector('.lx-price-slider__input--min');
    this.maxInput = this.querySelector('.lx-price-slider__input--max');
    this.rangeBar = this.querySelector('.lx-price-slider__range');
    this.max = Number(this.dataset.max || 0);

    this.minTarget = document.getElementById(this.dataset.minTarget);
    this.maxTarget = document.getElementById(this.dataset.maxTarget);

    if (!this.minInput || !this.maxInput || !this.rangeBar) return;

    this.minInput.addEventListener('input', () => this.onSliderInput('min'));
    this.maxInput.addEventListener('input', () => this.onSliderInput('max'));
    this.minInput.addEventListener('change', () => this.commit());
    this.maxInput.addEventListener('change', () => this.commit());

    // Fait passer le curseur qu'on vient de saisir au-dessus de l'autre,
    // pour toujours attraper le bon même quand ils sont proches/collés.
    this.minInput.addEventListener('pointerdown', () => this.bringToFront('min'));
    this.maxInput.addEventListener('pointerdown', () => this.bringToFront('max'));

    if (this.minTarget) {
      this.minTarget.addEventListener('change', () => {
        const val = Number(this.minTarget.value || 0);
        if (!Number.isNaN(val)) {
          const maxVal = Number(this.maxInput.value);
          this.minInput.value = Math.min(val, maxVal);
          this.updateRangeBar();
        }
      });
    }
    if (this.maxTarget) {
      this.maxTarget.addEventListener('change', () => {
        const val = Number(this.maxTarget.value || this.max);
        if (!Number.isNaN(val)) {
          const minVal = Number(this.minInput.value);
          this.maxInput.value = Math.max(val, minVal);
          this.updateRangeBar();
        }
      });
    }

    this.updateRangeBar();
  }

  bringToFront(which) {
    if (which === 'min') {
      this.minInput.style.zIndex = 2;
      this.maxInput.style.zIndex = 1;
    } else {
      this.maxInput.style.zIndex = 2;
      this.minInput.style.zIndex = 1;
    }
  }

  onSliderInput(which) {
    let minVal = Number(this.minInput.value);
    let maxVal = Number(this.maxInput.value);

    if (which === 'min' && minVal > maxVal) {
      minVal = maxVal;
      this.minInput.value = minVal;
    }
    if (which === 'max' && maxVal < minVal) {
      maxVal = minVal;
      this.maxInput.value = maxVal;
    }

    this.updateRangeBar();
  }

  updateRangeBar() {
    const minVal = Number(this.minInput.value);
    const maxVal = Number(this.maxInput.value);
    const minPercent = this.max ? (minVal / this.max) * 100 : 0;
    const maxPercent = this.max ? (maxVal / this.max) * 100 : 100;

    this.rangeBar.style.left = minPercent + '%';
    this.rangeBar.style.right = 100 - maxPercent + '%';
  }

  commit() {
  const minVal = Number(this.minInput.value);
  const maxVal = Number(this.maxInput.value);

  if (this.minTarget) {
    const newMin = String(minVal);
    if (this.minTarget.value !== newMin) {
      this.minTarget.value = newMin;
      this.minTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (this.maxTarget) {
    const newMax = String(maxVal);
    if (this.maxTarget.value !== newMax) {
      this.maxTarget.value = newMax;
      this.maxTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

}

customElements.define('price-range-slider', PriceRangeSlider);